<template>
    <div @click="open"
        class="note"
        :class="{active}"
        :draggable="draggable"
        @dragstart.stop="drag_start"
        @dragend.stop="drag_stop">

        <div class="dropdown is-right" :class="{'is-active': show_dropdown}" @mouseleave="show_dropdown = false">
            <div class="dropdown-trigger">
                <i v-if="space_permission('NOTE_DELETE') || space_permission('NOTE_UPDATE')"
                   @click.stop="show_dropdown = !show_dropdown"
                   class="icon fas fa-ellipsis-v"></i>
            </div>

            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <a v-if="is_trash && space_permission('NOTE_UPDATE')" @click.stop="restore" class="dropdown-item">
                        <i class="icon fas fa-arrow-up"></i>
                        Restore
                    </a>

                    <a v-if="space_permission('NOTE_UPDATE')" @click.stop="moving_note = note" class="dropdown-item">
                        <i class="icon fas fa-reply"></i>
                        Move to ...
                    </a>

                    <a v-if="space_permission('NOTE_UPDATE')" @click.stop="duplicate_preferences" class="dropdown-item">
                        <i class="icon fas fa-copy"></i>
                        Duplicate note
                    </a>

                    <a v-if="space_permission('NOTE_DELETE')" @click.stop="show_confirm = true" class="dropdown-item">
                        <i class="icon fas fa-trash-alt"></i>
                        Delete
                    </a>
                </div>
            </div>
        </div>

        <p class="title note-title is-6">
            <span :class="{'is-italic has-text-grey': !note.name, 'unread': note.is_unread}">
                {{note.name || 'Untitled'}}
            </span>
        </p>

        <div class="subtitle note-topic is-size-7 is-pulled-left">
            {{ !note.topic || note.is_private ? 'Private Notes' : note.topic.name }}
        </div>

        <div class="subtitle note-topic is-size-7 is-pulled-right date">
            <datetime :date="note.updated_at"/>
        </div>

        <note-move-modal :space="space" :note="moving_note" @close="moving_note = null" @moved="moved"/>

        <base-confirm-modal
            v-if="show_confirm"
            text="Do you really want to move this note to trash?"
            @close="show_confirm = false"
            @ok="remove"/>

        <note-duplicate-modal
            v-if="show_duplicate_modal"
            @close="show_duplicate_modal = false"
            @duplicate_note="duplicate_note"/>
    </div>
</template>

<script>
import { copy } from '../../utils/helpers';
import NoteMoveModal from './NoteMoveModal.vue';
import NoteDuplicateModal from './NoteDuplicateModal.vue';
import Datetime from '../base/Datetime.vue';

export default {
    name: 'NoteItem',
    components: { Datetime, NoteMoveModal, NoteDuplicateModal },
    props: ['space', 'note', 'is_trash', 'draggable'],
    data() {
        return {
            show_dropdown: false,
            moving_note: null,
            show_confirm: false,
            show_duplicate_modal: false,
        };
    },
    computed: {
        active() {
            return this.note.id === parseInt(this.$route.query.note, 10);
        },
    },
    methods: {
        open() {
            const query = copy(this.$route.query);
            query.note = this.note.id;
            this.$router.replace({ name: 'content', params: this.$route.params, query });
        },
        remove() {
            this.$store.dispatch('notes/remove', {
                space_id: this.space.id,
                note_id: this.note.id,
            }).then(() => {
                this.$store.commit('notes/remove_note', this.note.id);
                this.$store.commit('notes/clean_detail', this.note.id);
            });
        },
        restore() {
            this.$store.dispatch('notes/update', {
                space_id: this.space.id,
                note_id: this.note.id,
                data: { in_trash: false },
                patch: true,
            }).then(() => this.$store.commit('notes/remove_note', this.note.id));
        },
        moved(topic) {
            this.$store.commit('notes/change_note_topic', { note_id: this.note.id, topic });
            this.moving_note = null;
        },
        drag_start() {
            this.$store.commit('tree/start_moving', {
                source: 'notes_list',
                id: this.note.id,
                kind: 'note',
            });
        },
        drag_stop() {
            this.$store.commit('tree/stop_moving');
        },
        duplicate_preferences() {
            if (this.note.attachments_count > 0) {
                this.show_duplicate_modal = true;
            } else {
                this.duplicate_note();
            }
        },
        async duplicate_note(duplicate_attachments = false) {
            const { id } = await this.$store.dispatch('notes/duplicate', {
                space_id: this.space.id,
                note_id: this.note.id,
                data: { duplicate_attachments },
                is_tree_sidebar: false,
            });
            this.show_duplicate_modal = false;
            // Redirect to new note
            const query = { ...this.$route.query, note: id };
            this.$router.push({ name: 'content', params: this.$route.params, query });
        },
    },
};
</script>

<style scoped>
    .note {
        padding: 0.6rem;
        margin-bottom: 0.6rem;
        border-radius: 3px;
        background: #eeeded;
        cursor: pointer;
    }

    .note:hover, .note.active {
        background: #fbfafa;
    }

    .note-topic {
        color: #b5b5b5;
        display: inline;
    }

    .date {
        margin: -1.1rem 0.5rem 0 0;
    }

    .dropdown {
        float: right;
        top: 1px;
    }

    .unread {
        color: #000 !important;
        font-weight: 800;
    }

    .note-title {
        color: #464545;
        font-weight: 550;
    }
</style>
